/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _debounce from 'lodash/debounce'
import _get from 'lodash/get'
import { STORE_SAVE_INTERVAL } from 'constants/storeStructure'
import { initialState } from 'redux-app/modules/user'

const storage = localStorage
const STORE_KEY = 'EPSON'

export const loadState = () => {
  const { state = {}, version = 0 } = JSON.parse(storage.getItem(STORE_KEY)) || {}
  if (version && version !== __VERSION__) {
    console.warn('LocalStorage was cleaned')
    return {
      user: {
        ...initialState,
        isCookieAccepted: _get(state, ['user', 'isCookieAccepted'], false),
      },
    }
  }
  return state
}

const saveStore = _debounce(
  state => {
    storage.setItem(STORE_KEY, JSON.stringify({ state, version: __VERSION__ }))
  },
  STORE_SAVE_INTERVAL,
)

export const permanentMiddleware = ({ getState }) => next => action => {
  const result = next(action)
  const state = getState()
  const savedState = {
    ...state,
    alerts: {
      items: [],
    },
    apiData: {},
    entities: {},
    form: {},
    modals: {},
    user: {
      ...state.user,
      isPlanAcceptedMessageShown: false,
    },
    pageScroller: null,
  }
  saveStore(savedState)
  return result
}
